import { trim, walkArray } from "@/utils/commonUtil";
import { isOnlyAlphabetOrNumberOrChinese, isOnlyChinese } from "@/utils/validateUtil";
// & 基本表单校验
export const basicSetting = {
  title: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      const str = trim(value);
      if (str.length == 0) {
        error = new Error("问卷标题不能为空");
      }

      if (!isOnlyAlphabetOrNumberOrChinese(str)) {
        error = new Error("问卷标题只能包含中文、数字、英文字母");
      }
    } else {
      error = new Error("问卷标题不能为空");
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  introduce: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      if (trim(value).length == 0) {
        error = new Error("问卷介绍不能为空");
      }
      if (trim(value).length > 500) {
        error = new Error("问卷介绍不能超过500个字");
      }
    } else {
      error = new Error("问卷介绍不能为空");
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  remark: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      if (trim(value).length > 500) {
        error = new Error("问卷备注不能超过500个字");
      }
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  popupText: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (!value) {
      error = new Error("挽留文案不能为空");
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  leaveBtnText: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (!value) {
      error = new Error("离开按钮文案不能为空");
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  cancelBtnText: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (!value) {
      error = new Error("取消按钮文案不能为空");
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  validate(data: { title: string; introduce: string; remark: string; popupText: string; leaveBtnText: string; cancelBtnText: string; exitPopup: string }) {
    // console.log("validate", data);
    if (data.exitPopup == "1") {
      return this.title(null, data.title) && this.introduce(null, data.introduce) && this.remark(null, data.remark) && this.popupText(null, data.popupText) && this.leaveBtnText(null, data.leaveBtnText) && this.cancelBtnText(null, data.cancelBtnText);
    } else {
      return this.title(null, data.title) && this.introduce(null, data.introduce) && this.remark(null, data.remark);
    }
  },
};
// & 单、多选表单校验
export const choice = {
  title: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      const str = trim(value);
      if (str.length == 0) {
        error = new Error("题目标题不能为空");
      }

      // if (!isOnlyAlphabetOrNumberOrChinese(str)) {
      //   error = new Error("题目标题只能包含中文、数字、英文字母");
      // }
    } else {
      error = new Error("题目标题不能为空");
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  content: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      const str = trim(value);
      if (str.length == 0) {
        error = new Error("选项内容不能为空");
      }
    } else {
      error = new Error("选项内容不能为空");
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  optionsList: (rule: any, value: Array<{ content: string }>, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value.length < 2) {
      error = new Error("选项数量不能小于2");
    }
    walkArray(value, (item: { content: string }) => {
      if (item.content) {
        const str = trim(item.content);
        if (str.length == 0) {
          error = new Error("选项内容不能为空");
          return true;
        }
        if (str.length > 500) {
          error = new Error("选项内容的字数不能超过500个字");
          return true;
        }
      } else {
        error = new Error("选项内容不能为空");
        return true;
      }
    });
    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  validate(data: { title: string; optionsList: Array<{ content: string }> }) {
    if (this.title(null, data.title) && this.optionsList(null, data.optionsList)) {
      return true;
    } else {
      return false;
    }
  },
};
// & 填空表单校验
export const fillInValidate = {
  title: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      const str = trim(value);
      if (str.length == 0) {
        error = new Error("标题不能为空");
      }

      // if (!isOnlyAlphabetOrNumberOrChinese(str)) {
      //   error = new Error("题目标题只能包含中文、数字、英文字母");
      // }
    } else {
      error = new Error("标题不能为空");
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  content: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      if (trim(value).length > 500) {
        error = new Error("默认文本不能超过500个字");
      }
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  validate(data: { title: string; content: string }) {
    if (this.title(null, data.title) && this.content(null, data.content)) {
      return true;
    } else {
      return false;
    }
  },
};
// & 手机号校验
export const phoneNumValidate = {
  title: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      const str = trim(value);
      if (str.length == 0) {
        error = new Error("标题不能为空");
      }
      if (str.length > 500) {
        error = new Error("标题不能超过500个字");
      }
      // if (!isOnlyAlphabetOrNumberOrChinese(str)) {
      //   error = new Error("题目标题只能包含中文、数字、英文字母");
      // }
    } else {
      error = new Error("标题不能为空");
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  phoneNumber: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      if (trim(value).length > 500) {
        error = new Error("选项默认文本不能超过500个字");
      }
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  validate(data: { title: string; phoneNumber: string }) {
    if (this.title(null, data.title) && this.phoneNumber(null, data.phoneNumber)) {
      return true;
    } else {
      return false;
    }
  },
};
// & 上传附件表单校验
export const uploadAddonValidate = {
  title: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      const str = trim(value);
      if (str.length == 0) {
        error = new Error("标题不能为空");
      }
      if (str.length > 500) {
        error = new Error("标题不能超过500个字");
      }
      // if (!isOnlyAlphabetOrNumberOrChinese(str)) {
      //   error = new Error("题目标题只能包含中文、数字、英文字母");
      // }
    } else {
      error = new Error("标题不能为空");
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  validate(data: { title: string }) {
    if (this.title(null, data.title)) {
      return true;
    } else {
      return false;
    }
  },
};

// & 提交按钮表单校验
export const submitBtnValidate = {
  submitTitle: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      const str = trim(value);
      if (str.length == 0) {
        error = new Error("按钮文案不能为空");
      }
      if (str.length > 8) {
        error = new Error("按钮文案不能超过8个字");
      }
      if (!isOnlyChinese(str)) {
        error = new Error("按钮文案只能包含中文");
      }
    } else {
      error = new Error("按钮文案不能为空");
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  submitText: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      if (trim(value).length > 50) {
        error = new Error("按钮下方文案不能超过50个字");
      }
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  validate(data: { submitTitle: string; submitText: string }) {
    if (this.submitTitle(null, data.submitTitle) && this.submitText(null, data.submitText)) {
      return true;
    } else {
      return false;
    }
  },
};

// & 提交设置页校验
export const submitPageValidate = {
  title: (rule: any, value: string, callback?: (err?: Error) => void) => {
    let error = undefined;
    if (value) {
      if (trim(value).length == 0) {
        error = new Error("提交文案不能为空");
      }
      if (trim(value).length > 500) {
        error = new Error("提交文案不能超过500个字");
      }
    } else {
      error = new Error("提交文案不能为空");
    }

    if (callback) {
      callback(error);
    }
    if (error) {
      return false;
    }
    return true;
  },
  validate(data: { title: string }) {
    if (this.title(null, data.title)) {
      return true;
    } else {
      return false;
    }
  },
};
